import { Search } from "../partials/Search";
import React from "react";
import { AnimatePresence, motion } from "framer-motion";
export const SearchModal = () => {
  return (
    <div
      className="fixed inset-0 z-50 flex justify-center bg-[#004D5A33] bg-opacity-20"
      dir="rtl"
    >
      <AnimatePresence>
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0, transition: { duration: 0.2 } }}
          exit={{ y: 100, transition: { duration: 0.2 } }}
          className=" w-full"
        >
          <Search type="global" placeholder="ابحث عن سؤالك هنا" />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
